import { ITranslationState } from './models'

export const selectCurrentLocale = (state: { translations: ITranslationState }) =>
  state.translations.locale

export const selectDefaultLocale = (state: { translations: ITranslationState }) =>
  state.translations.defaultLocale

export const selectIsDefaultLocale = (state: { translations: ITranslationState }) =>
  state.translations.isDefaultLocale

export const selectTranslationMode = (state: { translations: ITranslationState }) =>
  state.translations.mode

export const selectIsInitialized = (state: { translations: ITranslationState }) =>
  state?.translations?.isInitialized || false
